

import QsButton from "./botton.vue"; 
const coms = [
    QsButton
]; // 将来如果有其它组件,都可以写到这个数组里
// 批量组件注册
const install = (vue) => {
    if (install.installed) return;
    coms.forEach((com) => {
        vue.component(com.name, com);
    });
};
export default install; // 这个方法以后再使用的时候可以被use调用